import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=5f11667b&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=5f11667b&prod&scoped=true&lang=css"
import style1 from "./UserPermissions.vue?vue&type=style&index=1&id=5f11667b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11667b",
  null
  
)

export default component.exports